import { render, staticRenderFns } from "./ComprometimentoDocumentacao.vue?vue&type=template&id=0df1f5a2&"
import script from "./ComprometimentoDocumentacao.vue?vue&type=script&lang=js&"
export * from "./ComprometimentoDocumentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports